import React, { useEffect } from "react"
import SignupLayout from ".";
import BackgroundImg from "../../assets/images/background/integrations.png";
import { ConnectionSignup, HomeIcon } from "../../components/Icons/iconImages";
import InputField from "../../components/InputField";
import { Button } from "antd";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from '../../components/Icons';
import { signInCognitoUser } from "../../services/auth";
import ReactGA from "react-ga4";
import { useCreateProfileFirstTimeMutation } from "../../services/createProfile";
import { toast } from "../../components/Toast/toast";

const SetupWorkspace = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [header, setHeader] = React.useState({})
  const defaultValues = {
    code: '',
    industry: "",
    role: "",
    companySize: "",
    url: ""
  };

  const {
    getValues,
    setValue,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues,
  });
  const [createProfileFirst, {
    data: createProfileData,
    error: createProfileError,
    isLoading: isCreatingProfile,
    isSuccess: isCreateProfileSuccess,
    isError: isCreateProfileError
  }] = useCreateProfileFirstTimeMutation();

  const signIn = async () => {
    try {
      const user: any = await signInCognitoUser(state.email, state.password);
      if (user) {
        const tempHeader = {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user?.idToken?.jwtToken}`,
        }
        setHeader(tempHeader);
      }
    } catch (err) {
      console.error('SignIn error:', err);
    }
  }
  
  useEffect(() => {
    if (state?.email && state?.password) {
      signIn();
    }
    if (state?.header) {
      setHeader(state?.header);
    }
    if (state?.aboutCompany) {
      setValue('code', state?.aboutCompany?.code);
      setValue('industry', state?.aboutCompany?.industry);
      setValue('role', state?.aboutCompany?.role);
      setValue('companySize', state?.aboutCompany?.companySize);
      setValue('url', state?.aboutCompany?.url);
    }
  }, [state])

  // Handle successful profile creation
  useEffect(() => {
    if (isCreateProfileSuccess && createProfileData) {
      // Store workspace ID if returned
      if (createProfileData?.workspace_id) {
        localStorage.setItem('workspace_id', createProfileData.workspace_id);
      }
    }
  }, [isCreateProfileSuccess, createProfileData])

  const handleCreateWorkspace = async (data: any) => {
    try {
      ReactGA.event('new_workspace_created', {
        method: 'manual_entry',
        user_type: 'new_user',
      });

      // Await the mutation and handle the response
      const result = await createProfileFirst(data).unwrap();
      
      // Only navigate on successful response
      if (result) {
        toast.success('Workspace created successfully!');
        navigate('/set-up-connection', {
          state: {
            ...state,
            header,
            aboutCompany: data
          }
        });
      }
    } catch (err: any) {
      console.error('Error creating workspace:', err);
      // Show error toast
      const errorMessage = err?.data?.message || err?.data?.error || 'Failed to create workspace. Please try again.';
      toast.error(errorMessage);
    }
  }
  const handleSubmitError = (data: any) => {
    // console.log('error triggered', data)
  }

  return (
    <SignupLayout
      title={<p className="text-white font-bold text-6xl 2xl:text-7xl mt-3">Connect & Listen to the stories your data is telling you</p>}
      description={<p className="text-white text-xl mt-3">Finish setting up and let AI reveal
        {' '}  <span className="relative border border-[#FDB022] text-[#F79009] font-semibold px-1.5 py-0.5 bg-[#325142] inline-block">
          <span className="absolute h-[5px] w-[5px] top-[-3px] left-[-3px] bg-[#FDB022]"></span>
          <span className="absolute h-[5px] w-[5px] top-[-3px] right-[-3px] bg-[#FDB022]"></span>
          <span className="absolute h-[5px] w-[5px] bottom-[-3px] right-[-3px] bg-[#FDB022]"></span>
          <span className="absolute h-[5px] w-[5px] bottom-[-3px] left-[-3px] bg-[#FDB022]"></span>
          hidden growth opportunities
        </span>{' '}
        across all your marketing channels.</p>}
      // background={BackgroundImg}
      icon={<ConnectionSignup className="h-[120px] w-[120px] " />}
      percent={50}
      currentStep={6}
      routeState={{
        ...state,
      header,
        aboutCompany: getValues()
      }
      }
    >
      <div className="mx-auto h-[calc(100vh-18.9rem)]">
        <div className="text-center mt-8">
          <div className="border border-gray-300 w-[56px] h-[56px] rounded-xl flex items-center justify-center m-auto shadow-sm">
            <HomeIcon className="w-6 h-auto" />
          </div>
          <p className="text-[#181D27] font-semibold text-3xl mt-4">Name your Workspace</p>
        </div>
        <form onSubmit={handleSubmit(handleCreateWorkspace, handleSubmitError)} className="flex flex-col items-center justify-between mt-6 h-full gap-6">
          <div className="border border-gray-300 shadow-sm max-w-[416px] p-4 rounded-2xl flex flex-col space-y-5 md:space-y-5 h-full">
            <InputField
              control={control}
              label={'Workspace Name'}
              placeholder={'Workspace Name'}
              type='text'
              name="workspace_id"
              rules={{
                required: 'Workspace Name is required',
              }}
              // error={errors.workspace_id}
              hint="e.g., {brandname}-workspace"
            />

            <div className="border border-t border-gray-200" />

            <p className="text-sm">Workspaces help you stay organised and easily find the data and conversations you are looking for</p>

            <div className="bg-[#E6F2EA] p-2.5">
              <p className="font-[#325142] text-sm">e.g., If you are managing 2 websites and would want to keep them separate.</p>
            </div>

            {isCreateProfileError && createProfileError && (
              <div className="flex items-center justify-between w-full border-t border-gray-200 dark:border-gray-600 pt-4">
                <p className='text-red-500 text-sm'>
                  {(createProfileError as any)?.data?.message || 
                   (createProfileError as any)?.data?.error || 
                   'Failed to create workspace. Please try again.'}
                </p>
                <Icons icon={"heroicons-outline:x-circle"} className="max-h-5 max-w-5 h-5 w-5 text-red-500 cursor-pointer" />
              </div>
            )}
          </div>
          <div className="flex items-center max-w-[416px] gap-3 w-full">
            {state?.header?.Authorization && <p className="text-[#609F81] cursor-pointer font-semibold" onClick={() => navigate('/select-goals', {
              state: {
                ...state,
              }
            })}>Back</p>}
            <Button
              type='primary'
              className="w-full"
              disabled={isCreatingProfile}
              loading={isCreatingProfile}
              htmlType="submit"
            >
              Continue
            </Button>
          </div>
        </form>
      </div>
    </SignupLayout>
  )
};

export default SetupWorkspace;
